import _ from 'lodash';
import { Service } from 'pdk/services';
import { UserPreferences } from '@/models';
import http from './http';
import Vue from 'vue';


export class AccountService extends Service {
	// CTOR
    constructor(httpService) {
        super();

        this.http = httpService || http;
    }


	// User groups
    getUserGroups(options) {
        const data = this._extend(options, {
            role: null
        });

        let url = 'ops/account/userlocationgroups';
        if (data.role != null) url += `?role=${data.role}`;

        return this.http.get(url, {
            transformResponse: [(data) => {
                let json = data;
                if (typeof data === 'string') json = JSON.parse(data);
                return _.orderBy(json.groups, [(g) => g.reportName]);
            }]
        }).then((response) => response.data);
    }
    getUserGroups_KendoDataSource(options) {
        const data = this._extend(options, {
            role: null
        });

        const fn = _.bind(this.getUserGroups, this);

        return {
            transport: {
                read(o) {
                    fn(data)
                        .then((groups) => {
                            o.success({
                                totalRows: groups.length,
                                data: groups
                            });
                        })
                        .catch((response) => {
                            o.error(response);
                        });
                }
            },
            pageSize: 20,
            schema: {
                total: 'totalRows',
                data: 'data',
                model: {
                    id: 'locationGroupID',
                    fields: {
                        name: { type: 'string', nullable: false },
                        reportName: { type: 'string', nullable: false },
                        dashboards: { type: 'number', nullable: false },
                        users: { type: 'number', nullable: false }
                    }
                }
            }
        };
    }

    // User roles
    getUserRoles() {
        return this.http.get('ops/account/userroles')
            .then((response) => response.data);
    }

    // User preferences
	getUserPreferences() {
        return this.http.get(`ops/account/preferences`, {
            transformResponse: [this.toJSON, (data) => {
                return UserPreferences.deserialize(data);
            }]
        }).then((response) => response.data);
	}
    updateUserPreferences(options) {

        // We're going to get the latest data first, then update it.
        // Return a Promise to ensure that we only return when all operations complete successfully.
        return new Promise((resolve, reject) => {

            // First, get the latest preferences
            this.getUserPreferences()
                .then((preferences) => {
                    // Update the preferences with the provided changes
                    preferences.update(options || {});
                    const updateRequest = preferences.serialize();

                    // Update the DB
                    this.http.post(`ops/account/preferences`, updateRequest)
                        .then(() => {

                            // Return the updated preferences. Match the Axios signature to reduce confusion.
                            resolve(preferences);
                        })
                        .catch((updateResponse) => {
                            reject(updateResponse);
                        });
                })
                .catch((getResponse) => {
                    reject(getResponse);
                });

        });
    }

    // Theme preferences
    getThemePreference() {
        return this.http.get(`ops/account/theme`)
            .then((response) => response.data);
    }
    updateThemePreference(options) {
        const data = this._extend(options, {
            theme: null
        });

        return this.http.put(`ops/account/theme`, data);
    }

    updateLastLogin() {
        return this.http.put(`ops/account/lastlogin`);
    }

    getUserDashboardPermissions() {
        return this.http.get(`ops/account/getUserDashboardPermissions`)
            .then((response) => response.data);
    }
}

export default new AccountService();
